/* aa-pdp-desktop-counter.js — PDP DESKTOP ONLY (≥750px), additive, no vendor edits.

   Saint-Laurent-style image counter for the desktop gallery (static_column_aside = a
   vertical stack of images). A small "current / total" marker fixed at the LEFT edge of
   the gallery, vertically centred in the viewport and overlaid on the photo. The current
   number tracks whichever stacked image is nearest the viewport centre as you scroll.

   Colour is a clean binary (white over dark photo areas / black over light) using the
   same luminance-sampling trick as the mobile helper, with a dark fallback if a CDN read
   is ever blocked. The element is built in JS and appended to <body> (fixed positioning),
   shown only while the gallery is on screen. */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var THRESH = 0.6;
  var ctx = null, corsCache = {};
  var el = null, curEl = null, totEl = null;
  var gallery = null, items = [];

  /* ---- luminance sampling (CORS-clean copy → 1×1 canvas) ---- */
  function sampleCtx() {
    if (!ctx) {
      var c = document.createElement('canvas');
      c.width = c.height = 1;
      ctx = c.getContext('2d', { willReadFrequently: true });
    }
    return ctx;
  }
  function corsImage(src, cb) {
    var e = corsCache[src];
    if (e) {
      if (e.img.complete) cb(e.ok ? e.img : null);
      else e.img.addEventListener('load', function () { cb(e.ok ? e.img : null); });
      return;
    }
    var img = new Image();
    e = corsCache[src] = { img: img, ok: false };
    img.crossOrigin = 'anonymous';
    img.onload = function () { e.ok = true; cb(img); };
    img.onerror = function () { e.ok = false; cb(null); };
    img.src = src;
  }
  function regionLuminance(img, fx, fy, fw, fh) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var sx = Math.max(0, Math.min(nw - 1, fx * nw));
    var sy = Math.max(0, Math.min(nh - 1, fy * nh));
    var sw = Math.max(1, Math.min(nw - sx, fw * nw));
    var sh = Math.max(1, Math.min(nh - sy, fh * nh));
    var c = sampleCtx();
    try {
      c.clearRect(0, 0, 1, 1);
      c.drawImage(img, sx, sy, sw, sh, 0, 0, 1, 1);
      var d = c.getImageData(0, 0, 1, 1).data;
      return (0.2126 * d[0] + 0.7152 * d[1] + 0.0722 * d[2]) / 255;
    } catch (err) { return null; }
  }

  /* ---- counter element ---- */
  function pad(n) { return '' + n; } /* plain number, no leading zero */

  function galleryEl() {
    return document.querySelector('.main-product-desktop-section-wrapper .product__media-list') ||
           document.querySelector('.product__outer--static-column-aside .product__media-list') ||
           document.querySelector('.product__media-wrapper .product__media-list');
  }

  function build() {
    gallery = galleryEl();
    if (!gallery) return false;
    items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    if (items.length < 2) return false;          // no counter for a single image
    if (!el) {
      el = document.createElement('div');
      el.className = 'aa-pdp-counter';
      curEl = document.createElement('span'); curEl.className = 'aa-pdp-counter__current';
      var sep = document.createElement('span'); sep.className = 'aa-pdp-counter__sep';
      totEl = document.createElement('span'); totEl.className = 'aa-pdp-counter__total';
      el.appendChild(curEl); el.appendChild(sep); el.appendChild(totEl);
      el.style.display = 'none';
      document.body.appendChild(el);
    }
    totEl.textContent = pad(items.length);
    return true;
  }

  function currentIndex() {
    var mid = window.innerHeight / 2, best = 0, bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      var d = Math.abs((r.top + r.height / 2) - mid);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  var pending = false;
  function update() {
    pending = false;
    if (!DESKTOP.matches) { if (el) el.style.display = 'none'; return; }
    if (!el && !build()) return;
    if (!gallery) return;

    var gr = gallery.getBoundingClientRect();
    var onScreen = gr.bottom > 0 && gr.top < window.innerHeight && gr.width > 0;
    if (!onScreen) { el.style.display = 'none'; return; }

    el.style.display = 'flex';
    el.style.left = (gr.left + 24) + 'px';       // left edge of the gallery + small inset

    var idx = currentIndex();
    curEl.textContent = pad(idx + 1);

    /* Adapt colour to the part of the current image behind the counter. */
    var img = items[idx] && items[idx].querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (!src) return;
    corsImage(src, function (ci) {
      var L = null;
      if (ci) {
        var ir = img.getBoundingClientRect();
        if (ir.width > 0 && ir.height > 0) {
          var px = (gr.left + 24) - ir.left, py = (window.innerHeight / 2) - ir.top;
          var fx = Math.min(0.95, Math.max(0, px / ir.width));
          var fy = Math.min(0.95, Math.max(0, py / ir.height));
          L = regionLuminance(ci, Math.max(0, fx - 0.04), Math.max(0, fy - 0.06), 0.12, 0.12);
        }
      }
      if (L === null) L = 1;                       // fallback: dark marks
      el.classList.toggle('aa-pdp-counter--light', L <= THRESH);
    });
  }

  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(update);
  }

  /* ---- adaptive zoom CURSOR ----
     A solid "+" cursor that flips colour to the pixel under the pointer: black "+" over
     light photo areas, white "+" over dark. CSS sets the base (black) + inheritance; here
     we sample the image luminance under the cursor on mousemove and swap the opener's
     inline cursor (children inherit it). */
  function cur(hex) {
    return "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'>" +
      "<path d='M12 4v16M4 12h16' stroke='%23" + hex + "' stroke-width='1.3' stroke-linecap='round'/></svg>\") 12 12, zoom-in";
  }
  var CUR_BLACK = cur('000'), CUR_WHITE = cur('fff');
  var movePending = false, mX = 0, mY = 0, mOpener = null, curState = null;

  function onMove(e) {
    if (!DESKTOP.matches) return;
    var op = e.target.closest ? e.target.closest('.product__modal-opener--image') : null;
    if (!op) return;
    mOpener = op; mX = e.clientX; mY = e.clientY;
    if (movePending) return;
    movePending = true;
    (window.requestAnimationFrame || window.setTimeout)(adaptCursor);
  }
  function adaptCursor() {
    movePending = false;
    var op = mOpener; if (!op) return;
    var img = op.querySelector('.product__media img') || op.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (!src) return;
    var r = img.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return;
    var fx = (mX - r.left) / r.width, fy = (mY - r.top) / r.height;
    if (fx < 0 || fx > 1 || fy < 0 || fy > 1) return;
    corsImage(src, function (ci) {
      var L = 1;
      if (ci) {
        var l = regionLuminance(ci, Math.max(0, fx - 0.03), Math.max(0, fy - 0.03), 0.06, 0.06);
        if (l !== null) L = l;
      }
      var want = L > 0.6 ? CUR_BLACK : CUR_WHITE;   // light area → black "+", dark → white "+"
      if (want !== curState) { curState = want; op.style.cursor = want; }
    });
  }

  function init() {
    build();
    schedule();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('mousemove', onMove, { passive: true });
    /* Images / gallery may finish laying out after us. */
    [300, 800, 1500].forEach(function (t) { window.setTimeout(schedule, t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', schedule);
  DESKTOP.addEventListener('change', schedule);
})();
